<form [formGroup]="addAlertForm" (ngSubmit)="addAlert()">
  <div class="row">
    <div class="form-group col-md-5">
      <label>Alert name <span class="text-danger small">(required)</span></label>
      <input type="text" class="form-control" [ngClass]="setClassInvalid(addAlertForm, 'name')" 
             formControlName="name" maxlength="40" placeholder="Alert name" required>
    </div>
    <div class="form-group col-md-5">
      <label class="me-1">Team members: <span class="text-danger small">(required)</span></label>
      <input type="hidden" class="form-control" formControlName="_users">
      <app-search-input [items]="[auth.currentUser]" model="user"></app-search-input>
    </div>
    <div class="form-group col-md-2">
      <label class="d-none d-lg-block">&nbsp;</label>
      <button class="btn btn-outline-primary d-block w-100 w-auto" type="submit" [disabled]="!addAlertForm.valid || isLoadingSearch || (keyword.length < 2 && person.length < 2)"
              data-bs-toggle="tooltip" data-placement="top" title="Enable email notifications for this search. You will receive up to 4 daily emails.">
        <i class="fa fa-bell"></i> Add alert
      </button>
    </div>
  </div>
</form>